// extracted by mini-css-extract-plugin
export var cardIcon = "_3t-4";
export var checkboxCard = "_3t-0";
export var checkboxCardSelected = "_3t-1";
export var disabled = "_3t-2";
export var outerBorder = "_3t-3";
export var spacerMedium = "_3t-7";
export var spacerSmall = "_3t-6";
export var spacerXsmall = "_3t-5";